import { IPortfolioEnvironmentalCredential } from '../../greenTypes';
import { formatValueAsString } from '../../../../utils/helpers';
import { useMemo } from 'react';

interface IEnvironmentalCredentialsProps {
	portfolioEnvironmentalCredential: IPortfolioEnvironmentalCredential | undefined;
	fleetCiiAlignment?: number | undefined;
	year: number;
}

const EnvironmentalCredentials: React.FC<IEnvironmentalCredentialsProps> = ({ ...props }) => {
	const options = useMemo(() => ({ minimumFractionDigits: 1, maximumFractionDigits: 1 }), []);

	return (
		<div className="p-4">
			<span className="font-bold mb-2">Portfolio Environmental Credentials</span>
			<div className="divide-y">
				<div className="flex justify-between py-2">
					<div>
						<p className="text-msi-darkblue-color font-semibold">CII Alignment</p>
						<p className="text-msi-darkgrey-color">(Current)</p>
					</div>
					<span className="text-black">
						{(props.fleetCiiAlignment && formatValueAsString(props.fleetCiiAlignment, options, '', '', '%')) || '-'}
					</span>
				</div>
				<div className="flex justify-between py-2">
					<div>
						<p className="text-msi-darkblue-color font-semibold">Poseidon Principles</p>
						<p className="text-msi-darkgrey-color">'Minimum' ({props.year})</p>
					</div>
					<span className="text-black">
						{(props.portfolioEnvironmentalCredential &&
							formatValueAsString(props.portfolioEnvironmentalCredential.ppTrajectoryMinimum, options, '', '', '%')) ||
							'-'}
					</span>
				</div>

				<div className="flex justify-between py-2">
					<div>
						<p className="text-msi-darkblue-color font-semibold">Poseidon Principles</p>
						<p className="text-msi-darkgrey-color">'Striving' ({props.year})</p>
					</div>
					<span className="text-msi-black-color">
						{(props.portfolioEnvironmentalCredential &&
							formatValueAsString(props.portfolioEnvironmentalCredential.ppTrajectoryStriving, options, '', '', '%')) ||
							'-'}
					</span>
				</div>
			</div>
		</div>
	);
};

export default EnvironmentalCredentials;
